// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("LatoRegular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("LatoItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("LatoBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("LatoBoldItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("LatoBlack.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("LatoBlackItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("LatoLight.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("LatoLightItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("LatoThin.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("LatoThinItalic.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype");
    font-family: "lato";
    font-style: normal;
    font-weight: normal;
}

@font-face {
    src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("truetype");
    font-family: "lato";
    font-style: italic;
    font-weight: normal;
}

@font-face {
    src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("truetype");
    font-family: "lato";
    font-style: normal;
    font-weight: bold;
}

@font-face {
    src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("truetype");
    font-family: "lato";
    font-style: italic;
    font-weight: bold;
}

@font-face {
    src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("truetype");
    font-family: "lato";
    font-style: normal;
    font-weight: 900;
}

@font-face {
    src: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("truetype");
    font-family: "lato";
    font-style: italic;
    font-weight: 900;
}

@font-face {
    src: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format("truetype");
    font-family: "lato";
    font-style: normal;
    font-weight: 300;
}

@font-face {
    src: url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format("truetype");
    font-family: "lato";
    font-style: italic;
    font-weight: 300;
}

@font-face {
    src: url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format("truetype");
    font-family: "lato";
    font-style: normal;
    font-weight: 100;
}

@font-face {
    src: url(${___CSS_LOADER_URL_REPLACEMENT_9___}) format("truetype");
    font-family: "lato";
    font-style: italic;
    font-weight: 100;
}
`, "",{"version":3,"sources":["webpack://./Styling/Fonts/Lato.css"],"names":[],"mappings":"AAAA;IACI,+DAA8C;IAC9C,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,+DAA6C;IAC7C,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,+DAA2C;IAC3C,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,+DAAiD;IACjD,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,+DAA4C;IAC5C,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,+DAAkD;IAClD,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,+DAA4C;IAC5C,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,+DAAkD;IAClD,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,+DAA2C;IAC3C,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,+DAAiD;IACjD,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;AACpB","sourcesContent":["@font-face {\n    src: url(\"LatoRegular.ttf\") format(\"truetype\");\n    font-family: \"lato\";\n    font-style: normal;\n    font-weight: normal;\n}\n\n@font-face {\n    src: url(\"LatoItalic.ttf\") format(\"truetype\");\n    font-family: \"lato\";\n    font-style: italic;\n    font-weight: normal;\n}\n\n@font-face {\n    src: url(\"LatoBold.ttf\") format(\"truetype\");\n    font-family: \"lato\";\n    font-style: normal;\n    font-weight: bold;\n}\n\n@font-face {\n    src: url(\"LatoBoldItalic.ttf\") format(\"truetype\");\n    font-family: \"lato\";\n    font-style: italic;\n    font-weight: bold;\n}\n\n@font-face {\n    src: url(\"LatoBlack.ttf\") format(\"truetype\");\n    font-family: \"lato\";\n    font-style: normal;\n    font-weight: 900;\n}\n\n@font-face {\n    src: url(\"LatoBlackItalic.ttf\") format(\"truetype\");\n    font-family: \"lato\";\n    font-style: italic;\n    font-weight: 900;\n}\n\n@font-face {\n    src: url(\"LatoLight.ttf\") format(\"truetype\");\n    font-family: \"lato\";\n    font-style: normal;\n    font-weight: 300;\n}\n\n@font-face {\n    src: url(\"LatoLightItalic.ttf\") format(\"truetype\");\n    font-family: \"lato\";\n    font-style: italic;\n    font-weight: 300;\n}\n\n@font-face {\n    src: url(\"LatoThin.ttf\") format(\"truetype\");\n    font-family: \"lato\";\n    font-style: normal;\n    font-weight: 100;\n}\n\n@font-face {\n    src: url(\"LatoThinItalic.ttf\") format(\"truetype\");\n    font-family: \"lato\";\n    font-style: italic;\n    font-weight: 100;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
